import { Link as RouterLink } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText'
import { useTheme } from "@mui/material";

export const SidebarItem = (props) => {

  const { drawerlink, itemicon, draweritem, isActive, disabled, onClick } = props

  const theme = useTheme();


    return (

<ListItem disablePadding sx={{ display: 'block', mb:0.5 }}>
      
      <ListItemButton
        component={RouterLink}
        to={drawerlink}
        onClick={onClick}
        disabled={disabled}
        sx={{
          ...(disabled && { opacity: 0.38, pointerEvents: 'none' }),
          minHeight: 18,
          px: 2,
          py: 0.5,
          borderRadius: '6px',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          
          // Default state
          '&:hover': {
            bgcolor: 'rgba(255, 255, 255, 0.08)',
            transform: 'translateX(2px)',
          },
          
          // Focus state (accessibility)
          '&:focus-visible': {
            bgcolor: 'rgba(255, 255, 255, 0.08)',
            outline: '2px solid rgba(255, 255, 255, 0.5)',
            outlineOffset: '2px',
          },
          
          // Active/Selected state
          '&.Mui-selected': {
            bgcolor: 'rgba(255, 255, 255, 0.12)',
            borderLeft: '3px solid',
            borderLeftColor: 'primary.main',
            pl: 'calc(16px - 3px)', // Compensate for border
            
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.16)',
            },
            
            // Active state indicator
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              width: '3px',
              height: '60%',
              bgcolor: 'primary.main',
              borderRadius: '0 2px 2px 0',
            }
          }
        }}
        >
      
            <ListItemIcon
            sx={{
                minWidth: 36,
                color: 'common.white',
                transition: 'color 0.2s ease',

                '& .MuiSvgIcon-root': {
                  fontSize: '1.25rem', // 20px - aligned with subtitle2
                },
              }}
            >
              {itemicon}
            </ListItemIcon>
           
           
            <ListItemText
          primary={draweritem}
          primaryTypographyProps={{
            variant: 'body1',
            sx: {
              color: isActive ? 'common.white' : 'rgba(255, 255, 255, 0.87)',
              fontWeight: isActive ? 500 : 400,
              letterSpacing: '0.03em',
              transition: 'all 0.2s ease',

              '.Mui-selected &': {
                color: 'common.white',
                fontWeight: 500,
              }
            }
          }}
        />

      </ListItemButton>
  </ListItem>

  )}